import  {eXcell,__extends} from './eXcell';
import eXcell_ed from './eXcell_ed';

var eXcell_math = (function (_super) {
    __extends(eXcell_math, _super);
    function eXcell_math(a) {
        _super.call(this);
        if (a) {
            this.cell = a;
            this.grid = this.cell.parentNode.grid;
        }
    }
    eXcell_math.prototype.edit = function () {
        this.grid.editor = new eXcell_ed(this.cell);
        this.grid.editor.fix_self = true;
        this.grid.editor.getValue = this.cell.original
            ? function () {
               
                return this.cell.original;
            }
            : this.getValue;
        this.grid.editor.setValue = this.setValue;
        this.grid.editor.edit();
    };
    eXcell_math.prototype.isDisabled = function () {
        return !this.grid._mathEdit;
    };
    eXcell_math.prototype.setValue = function (c) {
        c = this.grid._compileSCL(c, this.cell, this.fix_self);
        if (this.grid._strangeParams[this.cell._cellIndex]) {
            this.grid
                .cells5(this.cell, this.grid._strangeParams[this.cell._cellIndex])
                .setValue(c);
        }
        else {
            this.setCValue(c);
            this.cell._clearCell = false;
        }
    };
    eXcell_math.prototype.getValue = function () {
        if (this.grid._strangeParams[this.cell._cellIndex]) {
            return this.grid
                .cells5(this.cell, this.grid._strangeParams[this.cell._cellIndex])
                .getValue();
        }
        return this.cell.innerHTML;
    };
    return eXcell_math;
})(eXcell);
window.eXcell_math = eXcell_math;



// WEBPACK FOOTER //
// ./goingsrc/dx/dxSource/components/gridXCell/eXcell_math.js